import { computed, inject, Injectable } from '@angular/core';

import { EditModeStateService } from '@connect-services/client/services/edit-mode-state.service';
import { ProjectEntityTableService } from '@connect-services/client/services/project-entity-table.service';

@Injectable({
    providedIn: 'root',
})
export class LayerEditBadgeService {
    public readonly badgesByLayerName = computed<Map<string, boolean>>(() => {
        this.editModeStateService.getStateTick();

        const layersByName = this.projectEntityTableService.layersByName();
        if (!layersByName) {
            return new Map<string, boolean>();
        }

        const result = new Map<string, boolean>();

        for (const [layerName, layers] of layersByName.entries()) {
            const layerId = layers[0]?.id;
            if (!layerId) {
                result.set(layerName, false);
                continue;
            }

            result.set(layerName, this.editModeStateService.hasPendingEditsForLayer(layerId));
        }

        return result;
    });

    private readonly editModeStateService = inject(EditModeStateService);
    private readonly projectEntityTableService = inject(ProjectEntityTableService);

    public badgesForLayerNames(layerNames: string[]): boolean[] {
        if (!layerNames.length) {
            return [];
        }

        return layerNames.map((name) => this.badgesByLayerName().get(name) ?? false);
    }

    public hasPendingEditsForLayerName(layerName: string | null | undefined): boolean {
        if (!layerName) {
            return false;
        }

        return this.badgesByLayerName().get(layerName) ?? false;
    }
}
